import { useState } from "react";
import { Button, Flex, Modal } from "antd";
import { FileTextOutlined, SearchOutlined } from "@ant-design/icons";

export const TaskLogs = ({ console_log_tail, console_log_url }) => {
  const [showLogs, setShowLogs] = useState(false);

  const buttons = [];

  if (console_log_url) {
    buttons.push(
      <Button
        type="link"
        key="console_log_url"
        style={{
          color: "grey",
          padding: 0,
        }}
        href={console_log_url}
        target="_blank"
      >
        <FileTextOutlined />
      </Button>
    );
  }

  if (console_log_tail) {
    buttons.push(
      <Button
        type="link"
        key="console_log_tail"
        style={{
          color: "grey",
          padding: 0,
        }}
        onClick={() => setShowLogs(true)}
      >
        <SearchOutlined />
      </Button>
    );
  }

  if (buttons.length === 0) {
    return null;
  }

  return (
    <>
      <Modal width="85%" open={showLogs} footer={null} onCancel={() => setShowLogs(false)}>
        <div
          style={{
            height: "65vh",
          }}
        >
          <pre
            style={{
              fontSize: "12px",
              whiteSpace: "pre-wrap",
              wordWarp: "break-word",
              overflow: "auto",
              height: "auto",
              maxHeight: "100%",
              backgroundColor: "#eeeef4",
            }}
          >
            {console_log_tail}
          </pre>
        </div>
      </Modal>
      <Flex gap={5}>{buttons}</Flex>
    </>
  );
};
